export const MENTION_ALL_NICKNAME = 'all';

export function isMentionAll(nickname: string): boolean {
  return nickname.toLowerCase() === MENTION_ALL_NICKNAME;
}
